var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.505 9.3c1.12-1.12 3.074-1.12 4.195 0l.699.7 1.398-1.398-.7-.7a4.91 4.91 0 00-3.495-1.448 4.91 4.91 0 00-3.495 1.449L3.01 10a4.952 4.952 0 000 6.992 4.928 4.928 0 003.495 1.445 4.927 4.927 0 003.497-1.445l.699-.7-1.398-1.398-.7.7a2.973 2.973 0 01-4.195 0 2.971 2.971 0 010-4.196l2.098-2.097z",
    fill: "#2C5BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.008l-.699.7L10.7 5.104l.7-.699a2.973 2.973 0 014.195 0 2.971 2.971 0 010 4.196l-2.098 2.097c-1.12 1.12-3.075 1.12-4.195 0l-.699-.7-1.398 1.399.699.699a4.91 4.91 0 003.495 1.449 4.91 4.91 0 003.496-1.449L16.992 10a4.952 4.952 0 000-6.992 4.95 4.95 0 00-6.992 0z",
    fill: "#2C5BFF"
  })));
}
export default __webpack_public_path__ + "media/icons/copyLink-8d2c6604.svg";
export { SvgCopyLink as ReactComponent };